import React, { useState, useEffect } from 'react';
import Checkbox from '../../Checkbox/Checkbox';
import Alert from "../../AtomicAlert";

export const AcceptanceTerms = props => {

	const { acceptanceTerms, setAcceptanceTerms, label, linkText, href, errorMessage } = props;
	const [userAcceptedTerms, setUserAcceptedTerms] = useState(acceptanceTerms);

	useEffect(() => {
		setAcceptanceTerms(userAcceptedTerms);
	}, [userAcceptedTerms])

	return (
		<div className="acceptance-terms">
			<Checkbox
				id="userAcceptedTerms"
				name="userAcceptedTerms"
				onChange={options => setUserAcceptedTerms(options[0].checked)}
				options={[
					{
						label: (
							<span className="acceptance-terms--label">
								{label || 'Li e estou de acordo com os'}{' '}
								<a className="acceptance-terms--link" target="_blank" href={href || 'https://www.maxmilhas.com.br/terms/client-register'}>
									{linkText || 'Termos e condições.'}
								</a>
							</span>
						),
						name: "userAcceptedTerms",
						checked: userAcceptedTerms
					}
				]}
			/>
			{!userAcceptedTerms && userAcceptedTerms !== undefined && <Alert
				icon=" icon-max-navigation-close"
				type="danger"
			>
				{errorMessage || 'É necessário aceitar os termos e condições antes de prosseguir.'}
			</Alert>}
		</div>
	)
}
export default AcceptanceTerms